/* eslint-disable jira/filename-case */
import { Component, type FC, type Key, type LegacyRef } from 'react';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';
import ComponentWithAnalytics from '@jira/platform__analytics-web-react/src/utils/component-with-analytics.tsx';
import type { UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import type { LegacyBreadcrumbItem, LegacyBreadcrumbId } from '../types.tsx';
import registerBridge from './service/index.tsx';
import type { Props as BaseProps, AnalyticsEventProps } from './types.tsx';

type Props = BaseProps & AnalyticsEventProps;

// eslint-disable-next-line jira/react/no-class-components
class LegacyApiBridge extends Component<Props> {
	componentDidMount(): void {
		const { onInsertItem, onRemoveItem, onSetRenderTarget, onBreadCrumbsUpdate } = this;

		registerBridge({
			insertItem: onInsertItem,
			removeItem: onRemoveItem,
			render: onSetRenderTarget,
			onBreadCrumbsUpdate,
		});
	}

	/* eslint-disable jira/react-no-unneeded-arrow-function-properties */
	onInsertItem = (item: LegacyBreadcrumbItem): void => {
		const { onInsertItem, onInsertItemFired } = this.props;
		onInsertItemFired();

		onInsertItem(item);
	};

	onRemoveItem = (itemId: LegacyBreadcrumbId): void => {
		const { onRemoveItem, onRemoveItemFired } = this.props;
		onRemoveItemFired();

		onRemoveItem(itemId);
	};

	onSetRenderTarget = (element: HTMLElement): void => {
		const { onSetRenderTarget, onSetRenderTargetFired } = this.props;
		onSetRenderTargetFired();

		onSetRenderTarget(element);
	};

	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	onBreadCrumbsUpdate = (): any => {
		const { onOnBreadCrumbsUpdateFired } = this.props;
		onOnBreadCrumbsUpdateFired();

		return Observable.empty<never>();
	};
	/* eslint-enable jira/react-no-unneeded-arrow-function-properties */

	render() {
		return null;
	}
}

// @ts-expect-error - TS2719: two unrelated types with the same name (iso-decl artefact)
const defaultExport: FC<
	Omit<
		{
			onInsertItem: (arg1: LegacyBreadcrumbItem) => void;
			onRemoveItem: (arg1: LegacyBreadcrumbId) => void;
			onSetRenderTarget: (arg1: HTMLElement) => void;
			onInsertItemFired: (args_0: UIAnalyticsEvent) => void;
			onRemoveItemFired: (args_0: UIAnalyticsEvent) => void;
			onSetRenderTargetFired: (args_0: UIAnalyticsEvent) => void;
			onOnBreadCrumbsUpdateFired: (args_0: UIAnalyticsEvent) => void;
			ref?: LegacyRef<LegacyApiBridge> | undefined;
			key?: Key | null | undefined;
		},
		keyof WithAnalyticsEventsProps
	>
> = ComponentWithAnalytics('legacyApiBridge', {
	onInsertItemFired: 'apiMethodCalled',
	onRemoveItemFired: 'apiMethodCalled',
	onSetRenderTargetFired: 'apiMethodCalled',
	onOnBreadCrumbsUpdateFired: 'apiMethodCalled',
})(LegacyApiBridge);
export default defaultExport;
